import API from './axios.js';

export const getalllawyers = () => API.get('auth/all-lawyers');
export const getalllawyersCreatedByMe = () => API.get('auth/users-created-by-me');
export const createlawyers = (credentials) => API.post('auth/register/laywer', credentials);


export const updateUsers = (userID, payload) => API.patch(`auth/${userID}`,payload);
export const deleteAddedUser = (userID) => API.delete(`auth/${userID}`);




export const getUserLimit = () => API.get('company/limits');

export const uploadUsersSpreadsheetUsers = (formData) => {
  return API.post("auth/add-users-spreadsheet", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


